import posthog from 'posthog-js';

const key = import.meta.env.VITE_POSTHOG_KEY as string;
const host = import.meta.env.VITE_POSTHOG_HOST as string;

if (key) {
  posthog.init(key, {
    api_host: host || 'https://us.i.posthog.com',
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    enable_recording_console_log: false,
  });
}

export default posthog;
